"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyScheduleInfo = void 0;
const react_1 = __importDefault(require("react"));
require("./types");
const CommonScheduleInfo_1 = require("../CommonScheduleInfo");
const daily_svg_1 = __importDefault(require("../../../../assets/icons/scheduleInfo/daily.svg"));
const DailyScheduleInfo = ({ onShowPanel, scheduleInfoItems, scheduleEnabledField, isLoading, isToggleDisabled, t, }) => {
    return (react_1.default.createElement(CommonScheduleInfo_1.CommonScheduleInfo, { iconSrc: daily_svg_1.default, scheduleEnabledField: scheduleEnabledField, isToggleDisabled: isToggleDisabled, isLoading: isLoading, onShowPanel: onShowPanel, toggleLabel: t('scheduleInfo|form|fields|protectionEnabled|daily'), toggleTitleOff: t('scheduleInfo|toggleTitles|off'), toggleTitleOn: t('scheduleInfo|toggleTitles|on'), items: scheduleInfoItems, showPanelBtnLabel: t('scheduleInfo|actions|editSettings|daily') }));
};
exports.DailyScheduleInfo = DailyScheduleInfo;
//# sourceMappingURL=DailyScheduleInfo.js.map